export default __webpack_public_path__ + "static/media/port3.2cd59b95.jpg";